const OverwriteOptions = {
    Copy: 'Copy',
    Overwrite: 'Overwrite',
    Skip: 'Skip'
};

const TextureResolutionEnum = {
    ORIGINAL: "original",
    RESIZED: "resized"
};

module.exports = {
    OverwriteOptions,
    TextureResolutionEnum
}
